import { SearchServiceInterface, APIClientInterface, SearchResult, SingleResponse } from '../types'

export default class SearchService implements SearchServiceInterface {
	constructor(private client: APIClientInterface) {}

	public async search(searchString: string, abortSignal?: AbortSignal): Promise<SingleResponse<SearchResult[]>> {
		return this.client.get<SingleResponse<SearchResult[]>>(`/search?q=${searchString}`, null, abortSignal)
	}
}
